(function () {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const recentKey = 'lf-recently-viewed';

  function readRecent() {
    try {
      return JSON.parse(localStorage.getItem(recentKey) || '[]');
    } catch (error) {
      return [];
    }
  }

  function initStickyAtc() {
    const bar = document.querySelector('[data-lf-sticky-atc]');
    const trigger = document.querySelector('[data-lf-atc-trigger]');
    if (!bar || !trigger || window.matchMedia('(min-width: 750px)').matches) return;

    const update = () => {
      const rect = trigger.getBoundingClientRect();
      bar.classList.toggle('is-visible', rect.bottom < 0);
    };

    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
  }

  function escapeHtml(value) {
    return String(value ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function storeRecentlyViewed() {
    const node = document.querySelector('[data-lf-recent-product]');
    if (!node) return;

    let product;
    try {
      product = JSON.parse(node.textContent);
    } catch (error) {
      return;
    }
    if (!product || !product.id) return;

    const items = readRecent().filter((item) => String(item.id) !== String(product.id));
    items.unshift(product);
    localStorage.setItem(recentKey, JSON.stringify(items.slice(0, 8)));
  }

  function renderRecentlyViewed() {
    const holder = document.querySelector('[data-lf-recently-viewed]');
    const list = holder?.querySelector('[data-lf-recent-list]');
    if (!holder || !list) return;

    const current = document.querySelector('[data-product-id]')?.getAttribute('data-product-id');
    const items = readRecent().filter((item) => String(item.id) !== String(current)).slice(0, 4);
    if (!items.length) {
      holder.hidden = true;
      return;
    }

    holder.hidden = false;
    list.innerHTML = items
      .map((item) => {
        const title = escapeHtml(item.title);
        const url = escapeHtml(item.url);
        const image = escapeHtml(item.image);
        const price = escapeHtml(item.price);
        const compare = item.compare ? escapeHtml(item.compare) : '';
        return `
        <article class="lf-recent-card">
          <a class="lf-recent-card__link" href="${url}">
            <div class="lf-recent-card__media">
              ${image ? `<img src="${image}" alt="${title}" width="400" height="400" loading="lazy">` : ''}
            </div>
            <h3 class="lf-recent-card__title">${title}</h3>
            <p class="lf-recent-card__price">
              ${compare ? `<s>${compare}</s>` : ''}
              <span>${price}</span>
            </p>
          </a>
        </article>`;
      })
      .join('');
  }

  function initDesktopNavOverflow() {
    const list = document.querySelector('.lf-desktop-nav__list');
    const more = list?.querySelector('[data-lf-nav-more]');
    const moreList = more?.querySelector('[data-lf-nav-more-list]');
    if (!list || !more || !moreList) return;

    const items = Array.from(list.children).filter((item) => !item.hasAttribute('data-lf-nav-more'));
    let frame;

    const overflowing = (reserve) => {
      const limit = list.getBoundingClientRect().width - reserve;
      let used = 0;
      return items.filter((item) => {
        const width = item.getBoundingClientRect().width;
        if (used + width > limit) return true;
        used += width;
        return false;
      });
    };

    const layout = () => {
      if (!window.matchMedia('(min-width: 990px)').matches) {
        items.forEach((item) => list.insertBefore(item, more));
        more.hidden = true;
        moreList.replaceChildren();
        return;
      }

      items.forEach((item) => {
        item.hidden = false;
        list.insertBefore(item, more);
      });
      more.hidden = true;
      moreList.replaceChildren();

      let extras = overflowing(0);
      if (!extras.length) return;

      more.hidden = false;
      extras = overflowing(more.getBoundingClientRect().width + 8);
      extras.forEach((item) => {
        const label = (item.querySelector('summary span, :scope > a span, :scope > a')?.textContent || '').trim();
        const url = item.querySelector(':scope > a')?.href
          || item.querySelector('a.mega-menu__link')?.href
          || '/';
        const entry = document.createElement('li');
        entry.innerHTML = `<a class="mega-menu__link mega-menu__link--level-2 link" href="${url}">${label}</a>`;
        moreList.appendChild(entry);
        item.hidden = true;
      });
    };

    const schedule = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(layout);
    };

    layout();
    window.addEventListener('resize', schedule);
  }

  function initDesktopNavMenus() {
    const detailsList = Array.from(document.querySelectorAll('.lf-desktop-nav header-menu details'));
    if (!detailsList.length) return;

    const closeAll = (except) => {
      detailsList.forEach((details) => {
        if (details !== except) details.removeAttribute('open');
      });
    };

    detailsList.forEach((details) => {
      const summary = details.querySelector('summary');
      if (!summary) return;

      summary.addEventListener('click', (event) => {
        event.preventDefault();
        const shouldOpen = !details.hasAttribute('open');
        closeAll();
        if (shouldOpen) details.setAttribute('open', '');
      });
    });

    document.addEventListener('click', (event) => {
      if (!event.target.closest('.lf-desktop-nav')) closeAll();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeAll();
    });
  }

  function initCategorySlider() {
    document.querySelectorAll('slider-component.lf-cats__slider').forEach((root) => {
      const list = root.querySelector('.lf-cats__list');
      const prev = root.querySelector('button[name="previous"]');
      const next = root.querySelector('button[name="next"]');
      if (!list) return;

      const update = () => {
        const item = list.querySelector('.lf-cats__item');
        if (item) {
          const gap = parseFloat(getComputedStyle(list).gap) || 0;
          const offset = item.getBoundingClientRect().width + gap;
          const step = Math.max(1, Math.floor((list.clientWidth + gap) / offset));
          prev?.setAttribute('data-step', String(step));
          next?.setAttribute('data-step', String(step));
        }

        const max = Math.max(0, list.scrollWidth - list.clientWidth - 2);
        root.classList.toggle('is-start', list.scrollLeft <= 2);
        root.classList.toggle('is-end', list.scrollLeft >= max);
      };

      update();
      list.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
    });
  }

  function initProductCards() {
    document.querySelectorAll('[data-lf-card]').forEach((card) => {
      const source = card.querySelector('[data-lf-card-variants]');
      const optionGroups = card.querySelectorAll('[data-lf-card-options] [data-option-index]');
      if (!source || !optionGroups.length) return;

      let variants = [];
      try {
        variants = JSON.parse(source.textContent);
      } catch (error) {
        return;
      }

      const selected = Array.from(optionGroups).map((group) => {
        return group.querySelector('.is-selected')?.getAttribute('data-option-value') || '';
      });

      const applyVariant = (variant) => {
        if (!variant) return;
        const input = card.querySelector('[data-lf-card-variant]');
        const button = card.querySelector('.lf-card__atc');
        const image = card.querySelector('[data-lf-card-image]');
        const sale = card.querySelector('.price-item--sale');
        const regular = card.querySelector('.price-item--regular');
        const compare = card.querySelector('.price__sale s.price-item--regular');

        if (input) {
          input.value = variant.id;
          input.disabled = !variant.available;
        }
        if (button) button.disabled = !variant.available;
        if (image && variant.image) {
          image.src = variant.image;
          image.removeAttribute('srcset');
        }
        if (sale) sale.textContent = variant.price;
        else if (regular) regular.textContent = variant.price;
        if (compare) {
          if (variant.compare) {
            compare.textContent = variant.compare;
            compare.closest('span')?.removeAttribute('hidden');
          } else {
            compare.textContent = '';
          }
        }
        card.querySelectorAll('a.full-unstyled-link').forEach((link) => {
          if (variant.url) link.href = variant.url;
        });
      };

      const matchVariant = () => {
        return variants.find((variant) => {
          return selected.every((value, index) => !value || variant.options[index] === value);
        }) || variants.find((variant) => variant.available) || variants[0];
      };

      optionGroups.forEach((group, index) => {
        group.querySelectorAll('[data-option-value]').forEach((swatch) => {
          swatch.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            selected[index] = swatch.getAttribute('data-option-value') || '';
            group.querySelectorAll('[data-option-value]').forEach((node) => {
              const on = node === swatch;
              node.classList.toggle('is-selected', on);
              node.setAttribute('aria-pressed', on ? 'true' : 'false');
            });
            applyVariant(matchVariant());
          });
        });
      });
    });
  }

  document.addEventListener('toggle', (event) => {
    const item = event.target;
    if (!item || item.tagName !== 'DETAILS' || !item.open) return;
    const root = item.closest('[data-lf-faq]');
    if (!root) return;
    root.querySelectorAll('details').forEach((other) => {
      if (other !== item) other.open = false;
    });
  }, true);

  function initFeaturedProduct() {
    document.querySelectorAll('[data-lf-featured]').forEach((root) => {
      const source = root.querySelector('[data-lf-featured-variants]');
      const image = root.querySelector('[data-lf-featured-image]');
      const button = root.querySelector('.lf-featured__atc');
      const buttonLabel = button?.querySelector('span');
      let variants = [];
      try {
        variants = (source ? JSON.parse(source.textContent) : []).map((variant) => ({
          ...variant,
          options: (variant.options || []).map((value) => String(value).trim()),
        }));
      } catch (error) {
        variants = [];
      }

      const syncThumbs = (src) => {
        root.querySelectorAll('[data-lf-featured-thumb]').forEach((node) => {
          const on = Boolean(src) && node.dataset.image === src;
          node.classList.toggle('is-selected', on);
          node.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      };

      root.querySelectorAll('[data-lf-featured-thumb]').forEach((thumb) => {
        thumb.addEventListener('click', () => {
          if (image && thumb.dataset.image) {
            image.src = thumb.dataset.image;
            image.removeAttribute('srcset');
          }
          syncThumbs(thumb.dataset.image);
        });
      });

      const parseOption = (value) => {
        const text = String(value || '').trim();
        const colorMatch = text.match(/\(([^)]+)\)/);
        return {
          quality: /high/i.test(text) ? 'High' : /medium/i.test(text) ? 'Medium' : '',
          color: colorMatch ? colorMatch[1].trim() : '',
          raw: text,
        };
      };

      const parsedVariants = variants.map((variant) => ({
        ...variant,
        parsed: parseOption(variant.options[0]),
      }));

      if (button && !button.dataset.label) {
        button.dataset.label = (buttonLabel?.textContent || 'Add to cart').trim();
      }

      const writePrice = (variant) => {
        const inputs = root.querySelectorAll('[data-lf-featured-variant], .lf-featured__form [name="id"]');
        const current = root.querySelector('[data-lf-featured-current]');
        const compare = root.querySelector('[data-lf-featured-compare]');
        const save = root.querySelector('[data-lf-featured-save]');

        inputs.forEach((input) => {
          input.value = variant.id;
          input.disabled = !variant.available;
        });
        if (button) {
          button.disabled = !variant.available;
          button.removeAttribute('aria-disabled');
          if (buttonLabel) {
            buttonLabel.textContent = variant.available ? button.dataset.label || 'Add to cart' : 'Sold out';
          }
        }
        if (current) current.textContent = variant.price;
        if (compare) {
          compare.hidden = !variant.compare;
          if (variant.compare) compare.textContent = variant.compare;
        }
        if (save) {
          save.hidden = !(variant.save_pct || variant.save);
          if (variant.save_pct) save.textContent = `Save ${variant.save_pct}%`;
          else if (variant.save) save.textContent = `Save ${variant.save}`;
        }
        if (image && variant.image) {
          image.src = variant.image;
          image.removeAttribute('srcset');
          syncThumbs(variant.image);
        }
      };

      const splitRoot = root.querySelector('[data-lf-featured-split]');
      if (splitRoot && parsedVariants.length) {
        const qualityGroup = splitRoot.querySelector('[data-lf-featured-quality]');
        const colorGroup = splitRoot.querySelector('[data-lf-featured-color]');
        let quality = qualityGroup?.querySelector('button.is-selected')?.getAttribute('data-quality') || '';
        let color = colorGroup?.querySelector('button.is-selected')?.getAttribute('data-color') || '';

        const matchSplit = (prefer) => {
          const exact = parsedVariants.find(
            (variant) => variant.parsed.quality === quality && variant.parsed.color === color
          );
          if (exact) return exact;
          if (prefer === 'color') {
            return (
              parsedVariants.find((variant) => variant.parsed.color === color && variant.available) ||
              parsedVariants.find((variant) => variant.parsed.quality === quality && variant.available) ||
              parsedVariants[0]
            );
          }
          return (
            parsedVariants.find((variant) => variant.parsed.quality === quality && variant.available) ||
            parsedVariants.find((variant) => variant.parsed.color === color && variant.available) ||
            parsedVariants[0]
          );
        };

        const applySplit = (variant) => {
          if (!variant) return;
          quality = variant.parsed.quality || quality;
          color = variant.parsed.color || color;
          qualityGroup?.querySelectorAll('button[data-quality]').forEach((node) => {
            const on = node.getAttribute('data-quality') === quality;
            node.classList.toggle('is-selected', on);
            node.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          colorGroup?.querySelectorAll('button[data-color]').forEach((node) => {
            const value = node.getAttribute('data-color');
            const on = value === color;
            const exists = parsedVariants.some(
              (item) => item.available && item.parsed.quality === quality && item.parsed.color === value
            );
            node.classList.toggle('is-selected', on);
            node.classList.toggle('is-unavailable', !exists);
            node.hidden = !exists;
            node.setAttribute('aria-pressed', on ? 'true' : 'false');
            node.setAttribute('aria-hidden', exists ? 'false' : 'true');
          });
          const qualityLabel = qualityGroup?.querySelector('[data-lf-featured-quality-value]');
          const colorLabel = colorGroup?.querySelector('[data-lf-featured-color-value]');
          if (qualityLabel) qualityLabel.textContent = quality;
          if (colorLabel) colorLabel.textContent = color;
          writePrice(variant);
        };

        qualityGroup?.querySelectorAll('button[data-quality]').forEach((pill) => {
          pill.addEventListener('click', (event) => {
            event.preventDefault();
            quality = pill.getAttribute('data-quality') || '';
            applySplit(matchSplit('quality'));
          });
        });
        colorGroup?.querySelectorAll('button[data-color]').forEach((pill) => {
          pill.addEventListener('click', (event) => {
            event.preventDefault();
            color = pill.getAttribute('data-color') || '';
            applySplit(matchSplit('color'));
          });
        });
        applySplit(matchSplit());
        return;
      }

      const groups = root.querySelectorAll('[data-lf-featured-options] [data-option-index]');
      if (!groups.length || !variants.length) return;

      const selected = Array.from(groups).map((group) => {
        return group.querySelector('.is-selected')?.getAttribute('data-option-value') || '';
      });

      const matchVariant = () =>
        variants.find((variant) => selected.every((value, index) => !value || variant.options[index] === value)) ||
        variants.find((variant) => variant.available) ||
        variants[0];

      const markAvailability = () => {
        groups.forEach((group, index) => {
          group.querySelectorAll('[data-option-value]').forEach((pill) => {
            const value = pill.getAttribute('data-option-value');
            const exists = variants.some((variant) =>
              variant.available &&
              variant.options[index] === value &&
              selected.every((sel, i) => i === index || !sel || variant.options[i] === sel)
            );
            pill.classList.toggle('is-unavailable', !exists);
            pill.hidden = !exists;
            pill.setAttribute('aria-hidden', exists ? 'false' : 'true');
          });
        });
      };

      const applyVariant = (variant) => {
        if (!variant) return;
        variant.options.forEach((value, index) => {
          selected[index] = value;
          const group = groups[index];
          if (!group) return;
          group.querySelectorAll('[data-option-value]').forEach((node) => {
            const on = node.getAttribute('data-option-value') === value;
            node.classList.toggle('is-selected', on);
            node.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          const label = group.querySelector('[data-lf-featured-option-value]');
          if (label) label.textContent = value;
        });
        writePrice(variant);
        markAvailability();
      };

      groups.forEach((group, index) => {
        group.querySelectorAll('[data-option-value]').forEach((pill) => {
          pill.addEventListener('click', (event) => {
            event.preventDefault();
            selected[index] = pill.getAttribute('data-option-value') || '';
            applyVariant(matchVariant());
          });
        });
      });

      applyVariant(matchVariant());
    });
  }

  function labelCodButtons(root) {
    const scope = root && root.querySelectorAll ? root : document;
    const selector = [
      '.atebar-bt-modal__skip',
      '.atebar-bt__cod',
      '[data-atebar-bt-skip]',
      '.shopify-payment-button__button--unbranded',
      '#CartDrawer-Checkout',
      '.cart-drawer .cart__checkout-button',
    ].join(', ');
    const nodes = [...scope.querySelectorAll(selector)];
    if (root && root.matches && root.matches(selector)) nodes.push(root);
    nodes.forEach((node) => {
      const text = (node.textContent || '').replace(/\s+/g, ' ').trim();
      if (!text || /^cash on delivery$/i.test(text)) return;
      if (
        /continue without discount|without discount|continue to checkout|buy it now|buy now|check out|checkout/i.test(
          text
        )
      ) {
        node.textContent = 'Cash on Delivery';
      }
    });
  }

  function initClearCart() {
    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-lf-clear-cart]');
      if (!button || button.disabled) return;
      event.preventDefault();

      const drawer = document.querySelector('cart-drawer');
      button.disabled = true;

      const body = new URLSearchParams();
      body.set('sections', 'cart-drawer,cart-icon-bubble');
      body.set('sections_url', window.location.pathname);

      fetch(`${routes.cart_url}/clear.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'application/json',
        },
        body,
      })
        .then((response) => response.json())
        .then((data) => {
          if (!drawer) {
            window.location.assign(routes.cart_url);
            return;
          }
          if (data.sections && typeof drawer.renderContents === 'function') {
            drawer.renderContents(data);
          } else {
            drawer.classList.add('is-empty');
          }
          document.dispatchEvent(new CustomEvent('cart:updated'));
        })
        .catch(() => {
          button.disabled = false;
        });
    });
  }

  function initToTop() {
    const button = document.querySelector('[data-lf-to-top]');
    if (!button) return;
    button.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  function initCartFloater() {
    const floater = document.querySelector('[data-lf-cart-floater]');
    if (!floater) return;

    const sync = () => {
      const bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
      const count = (bubble?.querySelector('[aria-hidden="true"]')?.textContent || '').replace(/\D/g, '');
      const hasItems = Boolean(bubble);
      floater.hidden = !hasItems;
      floater.setAttribute('aria-hidden', hasItems ? 'false' : 'true');
      const countEl = floater.querySelector('[data-lf-cart-count]');
      if (countEl) {
        countEl.hidden = !(hasItems && count);
        if (count) countEl.textContent = count;
      }
    };

    const cartLink = document.getElementById('cart-icon-bubble');
    if (cartLink) {
      new MutationObserver(sync).observe(cartLink, { childList: true, subtree: true });
    }
    document.addEventListener('cart:updated', sync);
    sync();

    if (floater.dataset.lfCartBound === 'true') return;
    floater.dataset.lfCartBound = 'true';
    floater.addEventListener('click', (event) => {
      const drawer = document.querySelector('cart-drawer');
      if (!drawer || typeof drawer.open !== 'function') return;
      event.preventDefault();
      drawer.open(floater);
    });
  }

  function initCodLabels() {
    labelCodButtons(document);
    [400, 1200, 2500].forEach((ms) => window.setTimeout(() => labelCodButtons(document), ms));
    const observer = new MutationObserver((records) => {
      records.forEach((record) => {
        if (record.type === 'characterData') {
          labelCodButtons(record.target.parentElement || document);
          return;
        }
        record.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return;
          labelCodButtons(node);
        });
      });
    });
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  document.addEventListener('click', (event) => {
    const floater = event.target.closest('[data-lf-cart-floater]');
    if (!floater) return;
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.open !== 'function') return;
    event.preventDefault();
    drawer.open(floater);
  });

  document.addEventListener('DOMContentLoaded', () => {
    initStickyAtc();
    storeRecentlyViewed();
    renderRecentlyViewed();
    initDesktopNavOverflow();
    initDesktopNavMenus();
    initCategorySlider();
    initProductCards();
    initFeaturedProduct();
    initClearCart();
    initToTop();
    initCartFloater();
    initCodLabels();
    if (reduceMotion) document.documentElement.classList.add('lf-reduce-motion');
  });
})();
